import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import {
  BoardViewIcon,
  DownArrowIcon,
  IconButtonGroup,
  KbFileIcon,
  KbFolderIcon,
  ListViewIcon,
} from "components";
import { KbFileCard } from "./KbFileCard";
import { ReactNode, useState } from "react";
import { KbListViewFileCard, KbListViewFolderCard } from "./KbListViewCard";
import { KbFolderCard } from "./KbFolderCard";
import { useAtomValue, useSetAtom } from "jotai";
import { displayMode, setDisplayMode } from "../store/kbStore";

export const KbFileSection = ({
  files,
  title,
  icon,
  isSelectable = true,
}: {
  files: any[];
  title?: string;
  icon?: ReactNode;
  isSelectable?: boolean;
}) => {
  return (
    <KbSection
      items={files}
      type="file"
      title={title || "Articles"}
      isSelectable={isSelectable}
      icon={
        icon || (
          <KbFileIcon
            style={{
              width: "24px",
              height: "24px",
            }}
          />
        )
      }
    />
  );
};

export const KbFolderSection = ({
  folders,
  title,
  icon,
}: {
  folders: any[];
  title?: string;
  icon?: ReactNode;
}) => {
  return (
    <KbSection
      items={folders}
      type="folder"
      title={title || "Folders"}
      icon={
        icon || (
          <KbFolderIcon
            style={{
              width: "24px",
              height: "24px",
            }}
          />
        )
      }
    />
  );
};

const KbSection = ({
  items = [],
  type,
  title,
  icon,
  isSelectable,
}: {
  items: any[];
  type: "file" | "folder";
  title?: string;
  icon?: ReactNode;
  isSelectable?: boolean;
}) => {
  const theme = useTheme();

  const viewType = useAtomValue(displayMode);
  const getAccordionDetails = () => {
    if (type === "file") {
      return items?.map((item) =>
        viewType === "grid" ? (
          <KbFileCard
            key={item?.mapping_id}
            fileDetails={item}
            isSelectable={isSelectable}
          />
        ) : (
          <KbListViewFileCard key={item?.mapping_id} fileDetails={item} />
        ),
      );
    } else {
      return items?.map((item) =>
        viewType === "grid" ? (
          <KbFolderCard key={item?.mapping_id} folderDetails={item} />
        ) : (
          <KbListViewFolderCard key={item?.mapping_id} folderDetails={item} />
        ),
      );
    }
  };
  const accordionDetails = getAccordionDetails();
  return (
    <Accordion
      sx={{
        border: "none",
        borderBottom: `1px solid ${theme.palette.neutral["015"]}`,
        boxShadow: "none",
        borderRadius: "0 !important",
        "&:before": {
          display: "none",
        },
        margin: "0 !important",
        "&.Mui-expanded": {
          margin: "0 !important",
        },
      }}
      defaultExpanded={true}
    >
      <AccordionSummary
        expandIcon={<DownArrowIcon />}
        sx={{
          minHeight: "unset",
          "&.Mui-expanded": {
            minHeight: "unset",
          },
          "& .MuiAccordionSummary-content": {
            margin: "0px 0px",
          },
          "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: "0px 0px",
          },
          padding: "16px 32px",
        }}
      >
        <Stack
          direction="row"
          alignItems={"center"}
          gap="8px"
          flexGrow={1}
          pr="4px"
        >
          {icon}
          <Typography variant="subtitle1">{title}</Typography>
          <Stack
            ml="auto"
            direction="row"
            alignItems="center"
            gap="16px"
            sx={{
              visibility: "hidden",
              ".Mui-expanded &": {
                visibility: "visible",
              },
            }}
          >
            {/* <Typography
              variant="button-small"
              color="primary"
              sx={{
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              View All
            </Typography> */}
          </Stack>
        </Stack>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          p: 0,
        }}
      >
        <Stack
          direction={viewType === "grid" ? "row" : "column"}
          gap={viewType === "grid" ? "16px" : "8px"}
          flexWrap={"wrap"}
          px="24px"
          pb="16px"
        >
          {accordionDetails}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
